export default __webpack_public_path__ + "images/bell-notification.svg";